import { Controller } from '@hotwired/stimulus';

// 招待経由ログイン(パスワード設定)ページで、landing レイアウトの
// マーケティング導線を無効化する。旧 passwords/show の inline jQuery を移植:
// ロゴを非遷移化し、フッターの新規登録 CTA を隠し、フッターリンクは別タブで開く。
export default class extends Controller {
  connect() {
    const logo = document.querySelector('a#logo');
    if (logo) {
      logo.removeAttribute('href');
      logo.style.cursor = 'default';
    }

    document.querySelectorAll('#footer_signup a').forEach((a) => {
      a.style.visibility = 'hidden';
    });

    document.querySelectorAll('footer .footer_links a').forEach((a) => {
      a.setAttribute('target', '_blank');
    });
  }
}
